import { msg } from '@lingui/core/macro';

import type { Fund } from '@/modules/fund/public';
import { defineFilters } from '@/shared/filters/define-filters';
import { defineEntitySource } from '@/shared/form/entity-source';
import { getCurrentTenant } from '@/shared/http/client';

import { DIMENSA_STATUS } from './dimensa-submission.enums';

// Os 4 filtros (DimensaSubmissionListWithFilters.tsx:45-70, DimensaSubmissionFilters.tsx:26-31), na ordem do
// "Filtrar" do legado. Arquivo leve: entra no `validateSearch` da rota, então o fio do Cessionário vem por
// import dinâmico da porta do `fund`.

const funds = () => import('@/modules/fund/public');

/** Cessionário: `GET /Fund` com busca por texto (`useFundsList({ page: 0, size: 10 })`, DimensaSubmissionFilters.tsx:23). */
export const dimensaFundSource = defineEntitySource<Fund>({
  key: ['dimensa-submission', 'filter', 'fund'],
  scope: () => getCurrentTenant() ?? null,
  search: async (query, signal) => (await funds()).fundSource.search(query, signal),
  byId: async (id, signal) => (await funds()).fundSource.byId?.(id, signal),
  toOption: (item) => ({ value: item.id, label: item.name }),
});

/**
 * Data inicial do tipo `date` com `dateRangeName`: o legado manda `new Date(dia).toISOString()`, meia-noite de
 * São Paulo (filterContext.tsx:131-134 e :170-172; só a chave `initialDate` ganha o `-03:00`, :256-258). O fim
 * vai como `formatFinalDateWithTimeZone` (filterContext.tsx:93-99), o padrão do `dateRange`.
 */
export function dayStartIsoParam(day: string): string {
  return new Date(`${day}T00:00:00-03:00`).toISOString();
}

export const dimensaSubmissionFilters = defineFilters([
  { key: 'status', type: 'multiselect', label: msg`Status`, options: DIMENSA_STATUS, pinned: true },
  { key: 'fundId', type: 'entity', label: msg`Cessionário`, source: dimensaFundSource },
  {
    key: 'initialAssignmentDate',
    to: 'finalAssignmentDate',
    type: 'dateRange',
    label: msg`Data da cessão`,
    fromLabel: msg`Filtrar por data inicial`,
    toLabel: msg`Filtrar por data final`,
    fromParam: dayStartIsoParam,
    pinned: true,
  },
  {
    key: 'initialLastSubmittedAt',
    to: 'finalLastSubmittedAt',
    type: 'dateRange',
    label: msg`Data da última tentativa`,
    fromLabel: msg`Filtrar por data inicial`,
    toLabel: msg`Filtrar por data final`,
    fromParam: dayStartIsoParam,
  },
]);
